<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <div class="col-md-3 text-center text-md-right order-md-2">
        <div v-if="company.logo" class="pt-2">
          <v-lazy-image :src="company.logo" class="img-fluid" />
        </div>
      </div>
      <div class="col-md-9">
        <form-base
          :submit-status="submitStatus"
          action="Update"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
          class="py-5"
        >
          <template v-slot:fields>
            <div>
              <b-tabs content-class="mt-3">
                <b-tab title="Markups" active>
                  <form-group label="Labour Fee Partner" :required="true">
                    <input
                      type="number"
                      min="0"
                      class="form-control"
                      v-model="company.parameters.labour_fee_partner"
                    />
                  </form-group>

                  <form-group label="Labour Fee Client" :required="true">
                    <input
                      type="number"
                      min="0"
                      class="form-control"
                      v-model="company.parameters.labour_fee_client"
                    />
                  </form-group>

              

                  <form-group label="Parts Markup Partner%" :required="true">
                    <input
                      type="number"
                      min="0"
                      max="1000"
                      class="form-control"
                      v-model="company.parameters.parts_markup_partner"
                    />
                  </form-group>

                  <form-group label="Parts Markup Client%" :required="true">
                    <input
                      type="number"
                      min="0"
                      max="1000"
                      class="form-control"
                      v-model="company.parameters.parts_markup_client"
                    />
                  </form-group>

                  <small>*Assesment Fee on invoice</small>
                  <form-group
                    label="Quote Rejection Fee Partner"
                    :required="true"
                  >
                    <input
                      type="number"
                      min="0"
                      class="form-control"
                      v-model="
                        company.parameters.quotation_rejection_fee_partner
                      "
                    />
                  </form-group>

                  <small>*Assesment Fee on invoice</small>
                  <form-group
                    label="Quote Rejection Fee Client"
                    :required="true"
                  >
                    <input
                      type="number"
                      min="0"
                      class="form-control"
                      v-model="
                        company.parameters.quotation_rejection_fee_client
                      "
                    />
                  </form-group>

                  <small>*Handling Fee on invoice</small>
                  <form-group label="BER Fee Partner" :required="true">
                    <input
                      type="number"
                      min="0"
                      class="form-control"
                      v-model="company.parameters.ber_fee_partner"
                    />
                  </form-group>

                  <small>*Handling Fee on invoice</small>
                  <form-group label="BER Fee Client" :required="true">
                    <input
                      type="number"
                      min="0"
                      class="form-control"
                      v-model="company.parameters.ber_fee_client"
                    />
                  </form-group>
                </b-tab>
                <b-tab title="Email">
                  <form-group label="Mailer" :required="true">
                    <input
                      type="text"
                      class="form-control"
                      v-model="company.parameters.mail_mailer"
                    />
                  </form-group>

                  <form-group label="Host" :required="true">
                    <input
                      type="text"
                      class="form-control"
                      v-model="company.parameters.mail_host"
                    />
                  </form-group>

                  <form-group label="From Address" :required="true">
                    <input
                      type="text"
                      class="form-control"
                      v-model="company.parameters.mail_from_address"
                    />
                  </form-group>

                  <form-group label="From Name" :required="true">
                    <input
                      type="text"
                      class="form-control"
                      v-model="company.parameters.mail_from_name"
                    />
                  </form-group>

                  <form-group label="Encryption">
                    <input
                      type="text"
                      class="form-control"
                      v-model="company.parameters.mail_encryption"
                    />
                  </form-group>

                  <form-group label="Port" :required="true">
                    <input
                      type="text"
                      class="form-control"
                      v-model="company.parameters.mail_port"
                    />
                  </form-group>

                  <form-group label="SMTP Username">
                    <input
                      type="text"
                      class="form-control"
                      v-model="company.parameters.mail_username"
                    />
                  </form-group>

                  <form-group label="SMTP Password">
                    <input
                      type="text"
                      class="form-control"
                      v-model="company.parameters.mail_password"
                    />
                  </form-group>
                </b-tab>
                <b-tab title="SMS">
                  <form-group label="API Key" :required="true">
                    <input
                      type="text"
                      class="form-control"
                      v-model="company.parameters.sms_api_key"
                    />
                  </form-group>
                </b-tab>
                <b-tab title="Amazon S3">
                  <form-group label="Access Key ID">
                    <input
                      type="text"
                      class="form-control"
                      v-model="company.parameters.aws_access_key_id"
                    />
                  </form-group>

                  <form-group label="Secret Access Key">
                    <input
                      type="text"
                      class="form-control"
                      v-model="company.parameters.aws_secret_access_key"
                    />
                  </form-group>

                  <form-group label="Region">
                    <input
                      type="text"
                      class="form-control"
                      v-model="company.parameters.aws_default_region"
                    />
                  </form-group>

                  <form-group label="Bucket Name">
                    <input
                      type="text"
                      class="form-control"
                      v-model="company.parameters.aws_bucket"
                    />
                  </form-group>
                </b-tab>
                <b-tab title="General">
                  <form-group label="Technician Role" :required="true">
                    <b-form-select
                      @blur="$v.company.parameters.technician_role_id.$touch"
                      :class="{
                        'is-invalid': $v.company.parameters.technician_role_id.$error,
                      }"
                      v-model="company.parameters.technician_role_id"
                    >
                      <b-form-select-option
                        v-for="r in roles"
                        :value="r.id"
                        :key="r.id"
                        >{{ r.role }}</b-form-select-option
                      >
                    </b-form-select>
                    <div
                      class="invalid-feedback"
                      v-if="!$v.company.parameters.technician_role_id.required"
                    >
                      Please select Role
                    </div>
                  </form-group>
                   <form-group label="Domain">
                    <input
                      type="text"
                      class="form-control"
                      v-model="company.parameters.domain"
                    />
                  </form-group>
                   <form-group label="Currency">
                    <input
                      type="text"
                      class="form-control"
                      v-model="company.parameters.currency"
                    />
                  </form-group>
                   <form-group label="Damage Report Manager Name">
                    <input
                      type="text"
                      class="form-control"
                      v-model="company.parameters.damage_report_name"
                    />
                  </form-group>
                </b-tab>
              </b-tabs>
            </div>
          </template>
        </form-base>
      </div>
    </b-row>
  </div>
</template>

<script>
import companyRepo from "@/api/repos/companyRepo";
import { required } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";

export default {
  components: {
    formBase,
    formGroup,
  },

  validations: {
    company: {
      parameters: {
        parts_markup_client: {
          required,
        },
        parts_markup_partner: {
          required,
        },
        technician_role_id: {
          required,
        },
      },
    },
  },

  mounted() {
    this.getCompany();
  },

  data() {
    return {
      roles: [],
      company: {
        parameters: {
          spares_markup: "",
        },
      },
      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false,
    };
  },

  methods: {
    async getCompany() {
      try {
        this.loading = true;
        let { data } = await companyRepo.get(
          localStorage.getItem("current_company_id")
        );
        this.company = data.company;
        this.roles = data.roles;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$root.$bvToast.toast("Complete all required fields", {
          title: "Error",
          autoHideDelay: 3000,
          variant: "danger",
        });
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          await companyRepo.update(this.id, this.company);
          this.$root.$bvToast.toast("Company Updated", {
            title: "Success",
            autoHideDelay: 3000,
            variant: "success",
          });
          this.$router.push({ name: "companies" });
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>
